import {
    AMPLITUDE_OR_SCALE_CHANGE, CLOSE_IMAGE, FETCH_IMAGES_AND_USER_REQUEST, FETCH_IMAGES_AND_USER_SUCCESS, SWITCH_IMAGE_SUCCESS,
    SWITCH_USER_IMAGES
} from '../actions/ImageActions';
import {IMAGE_VIEWER_TOGGLE_ORIGINAL} from '../actions/PresetActions';
import {Defaults, ORIGINAL, POPPED} from '../Constants';
import {ACTIVE_IMAGE_CHANGE} from '../actions/EditorActions';
import {maybe} from '../utils';
import {isDemoAction} from './demo';

const initState = {
    id: null,
    lastVisitedId: null,
    userId: null,
    amplitude: Defaults.AMPLITUDE,
    spread: Defaults.SPATIAL_SCALE,
    isOriginalActive: false,
    activeImage: POPPED,
};

export const openImage = (state = initState, action) => {
    if (isDemoAction(action)) {
        return state;
    }
    switch (action.type) {
        case CLOSE_IMAGE: {
            return {...state, id: null};
        }
        case SWITCH_IMAGE_SUCCESS: {
            const {imageInfo} = action;
            const amplitude = maybe(imageInfo.amplitude, imageInfo.preferredAmplitude, Defaults.AMPLITUDE);
            const spread = maybe(imageInfo.spread, imageInfo.preferredSpread, Defaults.SPATIAL_SCALE);
            const {id, userId} = imageInfo;
            return {...state, id, lastVisitedId: id, userId, amplitude, spread, isOriginalActive: false, loading: false, error: null};
        }
        case FETCH_IMAGES_AND_USER_REQUEST: {
            const {user} = action;
            const userId = user.id;
            return {...state, userId};
        }
        case SWITCH_USER_IMAGES:
        case FETCH_IMAGES_AND_USER_SUCCESS: {
            const {user} = action;
            const userId = user.id;
            return {...state, userId, activeImage: POPPED};
        }
        case IMAGE_VIEWER_TOGGLE_ORIGINAL: {
            return {...state, isOriginalActive: !state.isOriginalActive};
        }
        case ACTIVE_IMAGE_CHANGE: {
            return {...state, isOriginalActive: action.imageType === ORIGINAL, activeImage: action.imageType};
        }
        case AMPLITUDE_OR_SCALE_CHANGE: {
            const {amplitude, spread, fromPreset} = action;
            if (fromPreset) {
                if (amplitude === state.amplitude && spread === state.spread) {
                    // the preset button is being toggled
                    return {...state, amplitude, spread, isOriginalActive: !state.isOriginalActive};
                } else {
                    return {...state, amplitude, spread, isOriginalActive: false};
                }
            }
            return {...state, amplitude, spread};
        }
        default:
            break;
    }
    return state;
};

export const getUserId = state => state.openImage.userId;



// WEBPACK FOOTER //
// ./src/reducers/openImage.js